import { graphql } from '@gql';

export const GET_PROJECT_DASHBOARD_SUMMARY_CARDS = graphql(`
    query GetProjectDashboardSummaryCards($pid: ID!) {
        getProjectDashboardSummaryCards(projectID: $pid) {
            assetsCount
            componentsCount
            projectZonesCount
            tasksCount
            tasksCompletedCount
            trasCount
            trasInProgressCount
            trasReadyForApprovalCount
            mitigationsCount
            survey {
                id
                classificationScore
                status
                classificationClassID
                classificationClassName
            }
        }
    }
`);

export const GET_DASHBOARD = graphql(`
    query GetDashboard {
        portalDashboard {
            projects {
                totalCount
                nodes {
                    id
                    name
                    organizationID
                    organizationName
                    projectTypeID
                    projectTypeName
                    projectStatusID
                    projectStatusName
                }
            }
            inProgressTasks {
                totalCount
                nodes {
                    id
                    title
                    priority
                    status
                }
            }
            notStartedTasks {
                totalCount
                nodes {
                    id
                    title
                    priority
                    status
                }
            }
            notifications {
                totalCount
                nodes {
                    id
                    title
                    source
                    priority
                    cvssVector
                    publishDate
                    cvss {
                        score
                        __typename
                    }
                }
            }
            assetItems {
                totalCount
            }
            projectZones {
                totalCount
            }
        }
    }
`);
